import styled from 'styled-components';
import { Skeleton } from 'ui/skeleton';
import { spacing } from 'ui/theme';
import { ListContainer } from './styles';

const ListRow = styled.div`
  display: flex;
  gap: ${spacing.x5};
`;

export const ALERT_LIST_SKELETON_TEST_ID = 'alert-list-skeleton';

export const AlertListSkeleton = () => {
  return (
    <ListContainer data-test={ALERT_LIST_SKELETON_TEST_ID}>
      {new Array(7).fill(null).map((_, index) => (
        <ListRow key={index}>
          <Skeleton key={`${index}-1`} height={20} width={250} isRound />
          <Skeleton key={`${index}-2`} height={20} width={320} isRound />
        </ListRow>
      ))}
    </ListContainer>
  );
};
